// src/components/Public/Navbar.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({
  t, language, setLanguage, theme, toggleTheme,
  mobileMenuOpen, setMobileMenuOpen, scrollToSection, isAdjuster
}) => {
  const handleSectionLink = (sectionId) => (e) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      scrollToSection(sectionId);
    } else {
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className={`navbar ${theme}`}>
      <div className="logo">
        <Link to="/" className="logo-container" onClick={handleSectionLink('inicio')}>
          <div className="logo-text">CSR <span>Claims Assistant</span></div>
        </Link>
      </div>

      <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`} id="navLinks">
        <Link to="/" onClick={handleSectionLink('inicio')}>{t.nav[0]}</Link>
        <Link to="/" onClick={handleSectionLink('servicios')}>{t.nav[1]}</Link>
        <Link to="/" onClick={handleSectionLink('quienes')}>{t.nav[2]}</Link>
        <Link to="/" onClick={handleSectionLink('equipo')}>{t.nav[3]}</Link>
        <Link to="/" onClick={handleSectionLink('clientes')}>{t.nav[4]}</Link>
        <Link to="/" onClick={handleSectionLink('contacto')}>{t.nav[5]}</Link>

        {!isAdjuster && (
          <Link to="/login" className="login-nav-btn" onClick={() => setMobileMenuOpen(false)}>
            <i className="fa-solid fa-user"></i>
            <span className="nav-text">{t.admin}</span>
          </Link>
        )}

        <div className="theme-toggle" onClick={toggleTheme} role="button" aria-label="Toggle theme">
          <i className={`fa-solid ${theme === 'light' ? 'fa-moon' : 'fa-sun'}`}></i>
        </div>
        <div className="lang-switch">
          <span className={language === 'es' ? 'active' : ''} onClick={() => setLanguage('es')}>ES</span> |
          <span className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>EN</span>
        </div>
      </div>

      <div className="hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} role="button" aria-label="Toggle menu">
        <i className={`fa-solid ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
      </div>
    </header>
  );
};

export default Navbar;
